import {connect} from 'react-redux'
import React from 'react'
import styled from 'styled-components'
import {Button, Link, Icon} from 'startlibs/lib/components'
import {isUploadingKeyImages} from 'report-components/lib/selectors'
import {togglePreview,unfinishDocument,finishDocument, changeTemplate} from 'report-components/lib/reducers'
import {withToggles} from 'startlibs/lib/hocs'

const NavbarButton = styled(Button)`
  padding-top: 10px;
  padding-bottom: 10px;
  line-height: 1;
  box-shadow: none;
  min-height: 32px;
  white-space: nowrap;
  ${Icon} {
    font-size: 19px;
    margin-right: 6px;
    margin-left: -6px;
  }
  ~ .styled-button {
    margin-left: 0.75rem;
  }
  :focus {
    :before {
      box-shadow: none;
    }
    :after {
      content: none;
    }
  }
`

export const reportTemplate = {
  title: (editing) => editing ? 'Report Viewer' : 'Report Editor',
  finishLabel: 'Finish report',
  editLabel: 'Edit report'
}

export const ReportNavbar = connect(({report, appUI},ownProps) => ({
  isChangingTemplate: appUI.loadings[changeTemplate],
  isFinishing: appUI.loadings[finishDocument],
  isUnfinishing: appUI.loadings[unfinishDocument],

  isDocumentFinished: report.finished,
  isPreviewOpen: report.isPreviewOpen,
  isReport: report.reportUID !== null,
  isUploadingKeyImages: isUploadingKeyImages(report.reportKeyImages),
  readOnly: report.readOnly,
  navigationDisabled: ownProps.navigationDisabled || report.navigationDisabled
}),{togglePreview,unfinishDocument,finishDocument})(
  withToggles('keyImagesDialog')(
    ({
       isChangingTemplate,
       isFinishing,
       isUnfinishing,

       isDocumentFinished,
       isPreviewOpen,
       isReport,
       isUploadingKeyImages,
       readOnly,
       navigationDisabled,

       togglePreview,
       finishDocument,
       unfinishDocument,
       isLocked,
       keyImagesDialog,
       template = reportTemplate
     }) => {
      const viewing = isPreviewOpen || isDocumentFinished
      return (
        <div className="navbar-content report-navbar center-container">
          <div className="left-container">
            {
              !navigationDisabled ?
              <NavbarButton TAG={Link} to="/" icon="arrow-left" outline white className="return-button">
                Reports list
              </NavbarButton>
              :
              <div className="logo-container"><div className="logo">Horos Cloud</div></div>
            }
          </div>
          <div className="central-container">
              <div className="report-status">{isPreviewOpen ? <span><span className="icon icon-view"/>Previewing</span> : template.title(isDocumentFinished || readOnly)}</div>
          </div>
          {
            !readOnly && !isLocked &&
            <div className="right-container">
              {
                !viewing && isReport &&
                <NavbarButton outline white disabled={isChangingTemplate} onClick={togglePreview}>Preview</NavbarButton>
              }
              {
                isPreviewOpen &&
                <NavbarButton outline white icon="edit" onClick={togglePreview}>{template.editLabel}</NavbarButton>
              }
              {
                isDocumentFinished &&
                <NavbarButton isLoading={isFinishing || isUnfinishing} icon="edit" outline white onClick={unfinishDocument}>
                  {template.editLabel}
                </NavbarButton>
              }
              {
                !isDocumentFinished &&
                <NavbarButton isLoading={isFinishing || isUnfinishing}
                        success
                        onClick={isUploadingKeyImages ? keyImagesDialog.open : finishDocument}
                        disabled={isChangingTemplate}>
                  {template.finishLabel}
                </NavbarButton>
              }
            </div>
          }

          {
            isLocked &&
            <div className="right-container">
              <NavbarButton locked icon="lock" disabled>Editing is Locked</NavbarButton>
            </div>
          }
        </div>
      )
    }))



// WEBPACK FOOTER //
// ./src/javascripts/report/ReportNavbar.jsx